export default "__VITE_ASSET__AFr5irKH__"